export default { sha: 'd7411d50a996bc9446f5ece78987e313b7de5eca', buildNumber: 'undefined' }
